/* eslint 'no-redeclare': 'off', 'no-useless-concat' :'off', eqeqeq: 'off'  */
import * as types from "../action/actionTypes";
import * as url from "../api/url";
import APIutil from "../api/APIutils";
import moment from "moment";
import { Base64 } from "js-base64";
import { GetTenantWorkOrderLicenseInfo } from "./Administration/administrationAction";
import { getServerType } from "action/Administration/license";
import { GetFacilityBackgroundImage } from "action/invoiceAction";

export function LogoutUser() {
  return function (dispatch) {
    return APIutil.postDataLogout()
      .then((response) => {
        dispatch(Logoutuser());
      })
      .catch((error) => {
        throw error;
      });
  };
}

// General Authentication system
/* 
    Autentication System Details
   - The Below Authentication system checks for the Status key in API JSON response if not calls APInotresponding dispatch method and displays connectivity error on the login Page.
   - Checks API JSON response data for error if yes does conitional visit to 
        -Invalid Credentials
        -Password Expired
        -EULA Acceptance
        - Proxy Errors 
        - Bad Gate Way
    -If JSON Response has token, first it initiates the refresh token mechanism. Second, verifies the User Role(user role is being fetched from client login pages).
    - If token available, calls login successful method.
*/

export function successfullLogin(dispatch, response, usercredentials) {
    return APIutil.getDataAPI(url.user_details_after_login)
    .then((resp1) => {
      var IsValidUser = true;
      if (resp1 !== undefined && resp1 !== null) {
        localStorage.setItem("TenantUserID", resp1.id);
        if (
          usercredentials.login_type == "tenant_employee" &&
          resp1.tenantUser == null
        ) {
          IsValidUser = false;
          dispatch(loginUnSuccessFull(response.data));
        }
        if (
          usercredentials.login_type != "tenant_employee" &&
          resp1.tenantUser != null
        ) {
          IsValidUser = false;
          dispatch(loginUnSuccessFull(response.data));
        }
      }
      if (IsValidUser) {
        if (usercredentials.login_type == "tenant_employee") {
          dispatch(GetFacilityBackgroundImage());
        }
        var user_preference = "",
          workorder_user_preference = "",
          preventative_maintenance_preference = "";
        var token_generated =
          response.data.value.token.accessToken.token;
        return APIutil.getDataAPI(url.user_preferences).then(
          (responses) => {
            if (
              usercredentials.login_type != "tenant_employee" &&
              responses.status != undefined &&
              responses.status == 403
            )
              //Check Whether user is not forbidden
              dispatch(Forbidden());
            else user_preference = responses;

            var data = null;
            user_preference.culture !== undefined
              ? (data = user_preference.culture)
              : (data = "en-US");

            APIutil.getDataAPI(
              url.get_tenant_workorder_licenseinfo
            ).then((res) => {
              if (
                res !== undefined &&
                res.licensedFeatures !== undefined &&
                res.licensedFeatures !== null &&
                res.licensedFeatures.length > 0 &&
                res.licensedFeatures[1].licensed
              ) {
                const actionresponse = import(
                  "../Resources/WorkOrders/WorkOrders." + data
                );

                if (usercredentials.login_type != "tenant_employee") {
                  APIutil.getDataAPI(
                    url.get_PrevenatativeMaintenanceStandardField
                  ).then((responses) => {
                    if (
                      usercredentials.login_type != "tenant_employee" &&
                      responses.length > 0
                    ) {
                      actionresponse.then((pm_resourceData) => {
                        let label = pm_resourceData.resourceData;

                        responses.forEach((fields) => {
                          fields.fieldLabel =
                            fields.fieldLabel != ""
                              ? fields.fieldLabel
                              : label[
                                  "PreventativeMaintenance.Options." +
                                    fields.fieldId +
                                    ".Text"
                                ];
                          if (fields.value.length > 0) {
                            fields.value.forEach((el) => {
                              if (
                                fields.fieldId == 1 &&
                                el.value == ""
                              ) {
                                el.value =
                                  label[
                                    "PreventativeMaintenance.Status." +
                                      el.key +
                                      ".Text"
                                  ];
                              }
                            });
                          }
                        });
                        preventative_maintenance_preference = responses;
                        // dispatch(preventative_maintenance_Preference_successfull(preventative_maintenance_preference));
                      });
                    } else {
                      var pm_options_Value;
                      actionresponse.then((pm_resourceData) => {
                        let label = pm_resourceData.resourceData;

                        var Status =
                          label[
                            "PreventativeMaintenance.Status.Text"
                          ].split(",");
                        var status_values = Status.map((el, i) => ({
                          key: el,
                          value:
                            label[
                              "PreventativeMaintenance.Status." +
                                el +
                                ".Text"
                            ],
                          isCustom: false,
                          orderId: el == 6 ? 999 : i,
                        }));
                        var status_short = status_values.map(
                          (el) => el.value
                        );
                        var status_short_text =
                          status_short.join(", ").substring(0, 30) +
                          (status_short.join(", ").length > 30
                            ? "..."
                            : "");

                        var Options =
                          label[
                            "PreventativeMaintenance.Options.Text"
                          ].split(",");
                        pm_options_Value = Options.map((el) => ({
                          field:
                            label[
                              "PreventativeMaintenance.Options." +
                                el +
                                ".Text"
                            ],
                          fieldLabel:
                            label[
                              "PreventativeMaintenance.Options." +
                                el +
                                ".Text"
                            ],
                          fieldId: el,
                          type:
                            el == 1 || el == 2 || el == 4 || el == 5
                              ? label[
                                  "WorkOrderSetup.SingleDropdown.Text"
                                ]
                              : el == 3 || el > 5
                              ? label["WorkOrderSetup.TextArea.Text"]
                              : "--",
                          value: el == 1 ? status_values : "--",
                          shortValue:
                            el == 1 ? status_short_text : "--",
                          display: true,
                          required: false,
                        }));
                        preventative_maintenance_preference =
                          pm_options_Value;
                        //dispatch(preventative_maintenance_Preference_successfull(preventative_maintenance_preference));
                      });
                    }

                    APIutil.getDataAPI(
                      url.get_WorkOrderStandardField
                    ).then((responses) => {
                      if (
                        usercredentials.login_type !=
                          "tenant_employee" &&
                        responses.length > 0
                      ) {
                        actionresponse.then((resourceData) => {
                          let label = resourceData.resourceData;
                          responses.forEach((fields) => {
                            fields.fieldLabel =
                              fields.fieldLabel != ""
                                ? fields.fieldLabel
                                : label[
                                    "WorkOrderSetup.Options." +
                                      fields.fieldId +
                                      ".Text"
                                  ];
                            if (fields.value.length > 0) {
                              fields.value.forEach((el) => {
                                if (
                                  fields.fieldId == 1 &&
                                  el.isCustom == false &&
                                  el.value == ""
                                ) {
                                  el.value =
                                    label[
                                      "WorkOrders.Status." +
                                        el.key +
                                        ".Text"
                                    ];
                                }
                                if (
                                  fields.fieldId == 3 &&
                                  el.isCustom == false &&
                                  el.value == ""
                                ) {
                                  el.value =
                                    label[
                                      "WorkOrders.Urgency." +
                                        el.key +
                                        ".Text"
                                    ];
                                }
                                if (
                                  fields.fieldId == 9 &&
                                  el.isCustom == false &&
                                  el.value == ""
                                ) {
                                  el.value =
                                    label[
                                      "WorkOrders.Problem." +
                                        el.key +
                                        ".Text"
                                    ];
                                }
                              });
                            }
                          });
                          workorder_user_preference = responses;
                          dispatch(
                            workorder_Preference_successfull(
                              workorder_user_preference
                            )
                          );
                          dispatch(
                            preventative_maintenance_Preference_successfull(
                              preventative_maintenance_preference
                            )
                          );
                        });
                      }
                    });
                  });
                }
              }
              // Refresh Mechanism
              var expirytime = new Date(
                response.data.value.token.accessToken.validTo
              ); //Initiate Automatic Refresh Mechanism
              const timeout = moment(expirytime).diff(
                moment(new Date())
              ); //Fetch Timeout from the access token expiry
              var expiryTimer = setInterval(() => {
                // this would reset localStorage before token expiry timr
                return APIutil.refreshToken().then((response) => {
                  if (
                    response.status == 500 ||
                    response.status == 502
                  ) {
                    clearInterval(expiryTimer);
                    dispatch(APInotresponding());
                  } else if (
                    response.status == 401 &&
                    response.statusText == "Unauthorized"
                  ) {
                    clearInterval(expiryTimer); //Refresh Token is expired
                    dispatch(loginUnSuccessFull(response.data));
                  }
                });
              }, timeout);

              var login_success_data = {
                jwt_token: token_generated,
                user_logged_in_type: usercredentials.login_type,
                user_preperence_details: user_preference,
                workorder_user_preference_details:
                  workorder_user_preference,
                preventative_maintenance_user_preferencedetails:
                  preventative_maintenance_preference,
              };
              localStorage.setItem("EULA_U", null);
              localStorage.setItem("EULA_P", null);
              dispatch(GetTenantWorkOrderLicenseInfo());
              dispatch(loginSuccessFull(login_success_data));
            });
          }
        );
      } else if (response.status == 200 && !IsValidUser) {
        dispatch(loginUnSuccessFull(response.data));
      } else {
        dispatch(APInotresponding()); // If API returns null token however, Status would be undefined (Extreme Case).
      }
    })
    .catch((error) => {
      dispatch(APInotresponding());
    });
}

export function authenticateUser(usercredentials) {
  sessionStorage.setItem("WorkOrderSortingDetails", null);
  sessionStorage.setItem("WorkOrderFilterDetails", null);
  sessionStorage.setItem("PMSortingDetails", null);
  sessionStorage.setItem("PMFilterDetails", null);
  //ASU Sessions
  sessionStorage.setItem("ASUInvoiceTabFilter", null);
  sessionStorage.setItem("ASUMonthlyTabFilter", null);
  let login_credentials = {
    username: usercredentials.username,
    password: usercredentials.password,
  };
  return function (dispatch) {
    return APIutil.getToken(login_credentials).then((response) => {
      // If API returns null token however, Status would be undefined (Extreme Case).
      if (response.hasOwnProperty("status")) {
        //Errors Handling
        if (response.data.hasOwnProperty("error")) {
          if (response.status == 401) {
            if (
              response.data.code == 6 &&
              response.data.error == "InvalidCredentials"
            ) {
              //Invalid Credentials or Un Successful Login
              dispatch(loginUnSuccessFull(response.data.error));
            } else if (
              response.data.code == 16 &&
              response.data.error == "AccountLocked"
            ) {
              //Account Locked
              dispatch(loginUnSuccessFull(response.data.error));
            } else if (
              response.data.code == 13 &&
              response.data.error == "PasswordExpired"
            ) {
              //Password Expired
              dispatch(passwordExpired());
            } else if (
              response.data.code == 14 &&
              response.data.error == "EulaNotAccepted"
            ) {
              //EULA Acceptance
              dispatch(EULAnotAccepted(login_credentials));
            }
          }
        }
        if (response.status == 400) {
          // 500 or 502 (Connection Error, Bad Gateway), If there is connectivity problem with the Server
          dispatch(APInotresponding());
        } else if (response.status == 500 || response.status == 502) {
          // 500 or 502 (Connection Error, Bad Gateway), If there is connectivity problem with the Server
          dispatch(APInotresponding());
        } else if (response.status == 403) {
          // 403, if user is forbidden
          dispatch(Forbidden());
        }

        // Logging User Based on Role
        if (
          response.status == 200 &&
          response.data !== "" &&
          response.data !== null
        ) {
          dispatch(getServerType("FM"));
          return successfullLogin(dispatch, response, usercredentials);
        }
      }
    });
  };
}

export function faciltySingleSignOnAction(traneConnectToken) {

    sessionStorage.setItem("WorkOrderSortingDetails", null);
    sessionStorage.setItem("WorkOrderFilterDetails", null);
    sessionStorage.setItem("PMSortingDetails", null);
    sessionStorage.setItem("PMFilterDetails", null);
    //ASU Sessions
    sessionStorage.setItem("ASUInvoiceTabFilter", null);
    sessionStorage.setItem("ASUMonthlyTabFilter", null);
    const usercredentials = {
        login_type: "tenant_employee",
    };

    return function (dispatch) {
      return APIutil.SingleSignOn(traneConnectToken).then((response) => {
        // If API returns null token however, Status would be undefined (Extreme Case).
        if (response.hasOwnProperty("status")) {
          //Errors Handling
          if (response.data.hasOwnProperty("error")) {         
            if (response.status == 401) {
              if (
                response.data.code == 6 &&
                response.data.error == "InvalidCredentials"
              ) {
                //Invalid Credentials or Un Successful Login
                dispatch(loginUnSuccessFull(response.data.error));
              } else if (
                response.data.code == 16 &&
                response.data.error == "AccountLocked"
              ) {
                //Account Locked
                dispatch(loginUnSuccessFull(response.data.error));
              } else if (
                response.data.code == 13 &&
                response.data.error == "PasswordExpired"
              ) {
                //Password Expired
                dispatch(passwordExpired());
              } else if (
                response.data.code == 14 &&
                response.data.error == "EulaNotAccepted"
              ) {
                //EULA Acceptance
                dispatch(EULAnotAccepted());
              }
            }
          }
          if (response.status == 400) {
            // 500 or 502 (Connection Error, Bad Gateway), If there is connectivity problem with the Server
            dispatch(APInotresponding());
          } else if (response.status == 500 || response.status == 502) {
            // 500 or 502 (Connection Error, Bad Gateway), If there is connectivity problem with the Server
            dispatch(APInotresponding());
          } else if (response.status == 403) {
            // 403, if user is forbidden
            dispatch(Forbidden());
          }
  
          // Logging User Based on Role
          if (
            response.status == 200 &&
            response.data !== "" &&
            response.data !== null
          ) {
            dispatch(getServerType("FM"));
            return successfullLogin(dispatch, response, usercredentials);
          }
        }
      });
    };
}

export function changePassword(encrypted_user_credentials) {
  let change_login_credentials = null;
  if (encrypted_user_credentials.hasOwnProperty("newpassword")) {
    change_login_credentials = {
      username: encrypted_user_credentials.username,
      password: encrypted_user_credentials.password,
      newpassword: encrypted_user_credentials.newpassword,
    };
    var encrypted_authenticated_detail = Base64.encode(
      encrypted_user_credentials.username +
        ":" +
        encrypted_user_credentials.password +
        ":" +
        encrypted_user_credentials.newpassword
    );
  } else if (encrypted_user_credentials.hasOwnProperty("EULA")) {
    var encrypted_authenticated_detail = Base64.encode(
      encrypted_user_credentials.username +
        ":" +
        encrypted_user_credentials.password +
        ":" +
        " " +
        ":true"
    );
  }

  return function (dispatch) {
    return APIutil.postChangePassword(encrypted_authenticated_detail)
      .then((response) => {
        // If API returns null token however, Status would be undefined (Extreme Case).

        if (response.hasOwnProperty("status")) {
          //Errors Handling
          if (response.data.hasOwnProperty("error")) {
            if (
              response.status == 401 &&
              response.data.code == 6 &&
              response.data.error == "InvalidCredentials"
            ) {
              //Invalid Credentials or Un Successful Login
              dispatch(loginUnSuccessFull(response.data));
            } else if (
              response.status == 401 &&
              response.data.code == 10 &&
              response.data.error == "PasswordViolatesHistoryPolicy"
            ) {
              //Password Used in History
              dispatch(passwordUsedInHistory());
            } else if (
              response.status == 401 &&
              response.data.code == 13 &&
              response.data.error == "PasswordExpired"
            ) {
              //Password Expired
              dispatch(passwordExpired());
            } else if (
              response.status == 401 &&
              response.data.code == 14 &&
              response.data.error == "EulaNotAccepted"
            ) {
              //EULA Acceptance
              dispatch(EULAnotAccepted(change_login_credentials));
            }
          }

          if (response.status == 400) {
            // 500 or 502 (Connection Error, Bad Gateway), If there is connectivity problem with the Server
            dispatch(APInotresponding());
          } else if (response.status == 500 || response.status == 502) {
            // 500 or 502 (Connection Error, Bad Gateway), If there is connectivity problem with the Server
            dispatch(APInotresponding());
          } else if (response.status == 403) {
            // 403, if user is forbidden
            dispatch(Forbidden());
          }

          // Logging User Based on Role
          if (
            response.status == 200 &&
            response.data !== "" &&
            response.data !== null
          ) {
            var token_generated = response.data.value.token.accessToken.token;

            // Refresh Mechanism
            var expirytime = new Date(
              response.data.value.token.accessToken.validTo
            ); //Initiate Automatic Refresh Mechanism
            const timeout = moment(expirytime).diff(moment(new Date())); //Fetch Timeout from the access token expiry
            var expiryTimer = setInterval(() => {
              // this would reset localStorage before token expiry timr
              return APIutil.refreshToken().then((response) => {
                if (response.status == 500 || response.status == 502) {
                  clearInterval(expiryTimer);
                  dispatch(APInotresponding());
                } else if (
                  response.status == 401 &&
                  response.statusText == "Unauthorized"
                ) {
                  clearInterval(expiryTimer); //Refresh Token is expired
                  dispatch(loginUnSuccessFull(response.data));
                }
              });
            }, timeout);

            var login_success_data = {
              jwt_token: token_generated,
              user_logged_in_type: encrypted_user_credentials.login_type,
            };
            //    localStorage.setItem('EULA', null);
            localStorage.setItem("EULA_U", null);
            localStorage.setItem("EULA_P", null);
            return dispatch(GetTenantWorkOrderLicenseInfo()).then(() => {
              dispatch(loginSuccessFull(login_success_data));
            });
          }
        } else {
          dispatch(APInotresponding()); // If API returns null token however, Status would be undefined (Extreme Case).
        }
      })
      .catch((error) => {
        dispatch(APInotresponding());
      });
  };
}

// Single Sign On  Authentication system for trane Connect users
export function SingleSignOnAction(traneConnectToken) {
  sessionStorage.setItem("WorkOrderSortingDetails", null);
  sessionStorage.setItem("WorkOrderFilterDetails", null);
  sessionStorage.setItem("PMSortingDetails", null);
  sessionStorage.setItem("PMFilterDetails", null);
  //ASU Sessions
  sessionStorage.setItem("ASUInvoiceTabFilter", null);
  sessionStorage.setItem("ASUMonthlyTabFilter", null);

  return function (dispatch) {
    return APIutil.SingleSignOn(traneConnectToken)
      .then((response) => {
        if (
          response !== undefined &&
          response.status == 200 &&
          response.data !== undefined &&
          response.data !== "" &&
          response.data !== null
        ) {
          dispatch(getServerType("FM"));
          var token_generated = response.data.value.token.accessToken.token;
          var user_preference = "",
            workorder_user_preference = "",
            preventative_maintenance_preference = "";
          var expirytime = new Date(
            response.data.value.token.accessToken.validTo
          );
          const timeout = moment(expirytime).diff(moment(new Date())); //Fetch Timeout from the access token expiry
          var expiryTimer = setInterval(() => {
            // this would reset localStorage before token expiry time
            return APIutil.refreshToken().then((responses) => {
              if (responses.status == 500 || responses.status == 502) {
                clearInterval(expiryTimer);
                dispatch(APInotresponding());
              } else if (
                responses.status == 401 &&
                responses.statusText == "Unauthorized"
              ) {
                //refresh token is no longer valid
                clearInterval(expiryTimer); //Un Successful Login
                dispatch(loginUnSuccessFull(response.data));
              }
              //If the Refresh is successfull continue to refresh it with the timer
            });
          }, timeout);

          return APIutil.getDataAPI(url.user_details_after_login).then(
            (resp) => {
              var userType =
                resp.tenantUser != null
                  ? "tenant_employee"
                  : "property_manager";
              if (userType == "tenant_employee") {
                dispatch(GetFacilityBackgroundImage());
              }
              if (resp !== undefined && resp !== null)
                localStorage.setItem("TenantUserID", resp.id);
              var login_success_data = {
                jwt_token: token_generated,
                user_logged_in_type: userType,
              };
              return APIutil.getDataAPI(url.user_preferences).then((res) => {
                if (res.status != undefined && res.status == 403)
                  //Check Whether user is not forbidden
                  dispatch(Forbidden());
                else user_preference = res;

                var property_manger_login_success_data = {
                  jwt_token: token_generated,
                  user_logged_in_type: login_success_data.user_logged_in_type,
                  user_details_complete_info: resp,
                  user_preperence_details: user_preference,
                };
                dispatch(GetTenantWorkOrderLicenseInfo());
                dispatch(
                  property_manager_loginSuccessFull(
                    property_manger_login_success_data
                  )
                );

                var data = null;
                data =
                  user_preference.culture != undefined
                    ? user_preference.culture
                    : "en-US";
                APIutil.getDataAPI(url.get_tenant_workorder_licenseinfo).then(
                  (res) => {
                    if (
                      res !== undefined &&
                      res.licensedFeatures !== undefined &&
                      res.licensedFeatures !== null &&
                      res.licensedFeatures.length > 0 &&
                      res.licensedFeatures[1].licensed
                    ) {
                      const actionresponse = import(
                        "../Resources/WorkOrders/WorkOrders." + data
                      );

                      if (userType != "tenant_employee") {
                        return APIutil.getDataAPI(
                          url.get_PrevenatativeMaintenanceStandardField
                        ).then((responses) => {
                          if (responses.length > 0) {
                            actionresponse.then((pm_resourceData) => {
                              let label = pm_resourceData.resourceData;

                              responses.forEach((fields) => {
                                fields.fieldLabel =
                                  fields.fieldLabel != ""
                                    ? fields.fieldLabel
                                    : label[
                                        "PreventativeMaintenance.Options." +
                                          fields.fieldId +
                                          ".Text"
                                      ];
                                if (fields.value.length > 0) {
                                  fields.value.forEach((el) => {
                                    if (
                                      fields.fieldId == 1 &&
                                      el.isCustom == false &&
                                      el.value == ""
                                    ) {
                                      el.value =
                                        label[
                                          "PreventativeMaintenance.Status." +
                                            el.key +
                                            ".Text"
                                        ];
                                    }
                                  });
                                }
                              });
                              preventative_maintenance_preference = responses;
                              dispatch(
                                preventative_maintenance_Preference_successfull(
                                  preventative_maintenance_preference
                                )
                              );
                            });
                          } else {
                            var pm_options_Value;
                            actionresponse.then((pm_resourceData) => {
                              let label = pm_resourceData.resourceData;

                              var Status =
                                label[
                                  "PreventativeMaintenance.Status.Text"
                                ].split(",");
                              var status_values = Status.map((el, i) => ({
                                key: el,
                                value:
                                  label[
                                    "PreventativeMaintenance.Status." +
                                      el +
                                      ".Text"
                                  ],
                                isCustom: false,
                                orderId: el == 6 ? 999 : i,
                              }));
                              var status_short = status_values.map(
                                (el) => el.value
                              );
                              var status_short_text =
                                status_short.join(", ").substring(0, 30) +
                                (status_short.join(", ").length > 30
                                  ? "..."
                                  : "");

                              var Options =
                                label[
                                  "PreventativeMaintenance.Options.Text"
                                ].split(",");
                              pm_options_Value = Options.map((el) => ({
                                field:
                                  label[
                                    "PreventativeMaintenance.Options." +
                                      el +
                                      ".Text"
                                  ],
                                fieldLabel:
                                  label[
                                    "PreventativeMaintenance.Options." +
                                      el +
                                      ".Text"
                                  ],
                                fieldId: el,
                                type:
                                  el == 1 || el == 2 || el == 4 || el == 5
                                    ? label[
                                        "WorkOrderSetup.SingleDropdown.Text"
                                      ]
                                    : el == 3 || el > 5
                                    ? label["WorkOrderSetup.TextArea.Text"]
                                    : "--",
                                value: el == 1 ? status_values : "--",
                                shortValue: el == 1 ? status_short_text : "--",
                                display: true,
                                required: false,
                              }));
                              preventative_maintenance_preference =
                                pm_options_Value;
                              dispatch(
                                preventative_maintenance_Preference_successfull(
                                  preventative_maintenance_preference
                                )
                              );
                            });
                          }

                          ///Start
                          return APIutil.getDataAPI(
                            url.get_WorkOrderStandardField
                          ).then((responses) => {
                            if (responses.length > 0) {
                              actionresponse.then((resourceData) => {
                                let label = resourceData.resourceData;
                                responses.forEach((fields) => {
                                  fields.fieldLabel =
                                    fields.fieldLabel != ""
                                      ? fields.fieldLabel
                                      : label[
                                          "WorkOrderSetup.Options." +
                                            fields.fieldId +
                                            ".Text"
                                        ];
                                  if (fields.value.length > 0) {
                                    fields.value.forEach((el) => {
                                      if (
                                        fields.fieldId == 1 &&
                                        el.isCustom == false &&
                                        el.value == ""
                                      ) {
                                        el.value =
                                          label[
                                            "WorkOrders.Status." +
                                              el.key +
                                              ".Text"
                                          ];
                                      }
                                      if (
                                        fields.fieldId == 3 &&
                                        el.isCustom == false &&
                                        el.value == ""
                                      ) {
                                        el.value =
                                          label[
                                            "WorkOrders.Urgency." +
                                              el.key +
                                              ".Text"
                                          ];
                                      }
                                      if (
                                        fields.fieldId == 9 &&
                                        el.isCustom == false &&
                                        el.value == ""
                                      ) {
                                        el.value =
                                          label[
                                            "WorkOrders.Problem." +
                                              el.key +
                                              ".Text"
                                          ];
                                      }
                                    });
                                  }
                                });
                                workorder_user_preference = responses;
                                dispatch(
                                  workorder_Preference_successfull(
                                    workorder_user_preference
                                  )
                                );
                              });
                            }
                          });
                        });
                      }
                    }
                  }
                );
              });
            }
          );
        } else {
          if (response !== undefined) {
            var OnPremise = localStorage.getItem("isOnPremise");
            if (OnPremise == "false" && "loginUrl" in response.data) {
              dispatch(
                actionToStoreSuccess(
                  response.data.loginUrl,
                  types.SINGLE_SIGN_ON_FAILED
                )
              );
            } else {
              dispatch(ErrorSatus(response.status));
            }
          }
        }
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function property_manager_loginSuccessFull(
  property_manger_login_success_data
) {
  return {
    type: types.USER_AUTH_SUCCESSFULL,
    token: property_manger_login_success_data.jwt_token,
    user_type: property_manger_login_success_data.user_logged_in_type,
    user_details_complete_infos:
      property_manger_login_success_data.user_details_complete_info,
    user_preferencedetails:
      property_manger_login_success_data.user_preperence_details,
  };
}

export function loginSuccessFull(login_success_data) {
  return {
    type: types.USER_AUTH_SUCCESSFULL,
    token: login_success_data.jwt_token,
    user_type: login_success_data.user_logged_in_type,
    user_preferencedetails: login_success_data.user_preperence_details,
    workorder_user_preferencedetails:
      login_success_data.workorder_user_preference_details,
    preventative_maintenance_user_preferencedetails:
      login_success_data.preventative_maintenance_user_preferencedetails,
  };
}

export function workorder_Preference_successfull(
  workorder_user_preference_details
) {
  return {
    type: types.WORKORDER_PREFERENCE_SUCCESSSFULL,
    workorder_user_preferencedetails: workorder_user_preference_details,
  };
}

export function preventative_maintenance_Preference_successfull(
  preventative_maintenance_preference_details
) {
  return {
    type: types.PREVENTATIVE_PREFERENCE_SUCCESSSFULL,
    preventative_maintenance_user_preferencedetails:
      preventative_maintenance_preference_details,
  };
}

export function loginUnSuccessFull(response) {
  return {
    type: types.USER_AUTH_UNSUCCESSFULL,
    error_response: response,
  };
}

export function Logoutuser() {
  return {
    type: types.LOGOUT_USER,
  };
}
//password System

export function passwordExpired() {
  return {
    type: types.PASSWORD_EXPIRED,
  };
}
export function passwordUsedInHistory() {
  return {
    type: types.PASSWORD_USED_IN_HISTORY_ERROR,
  };
}
export function APInotresponding() {
  return {
    type: types.API_NOT_RESPONDING,
  };
}

export function EULAnotAccepted(login_credentials) {
  return {
    type: types.EULA_NOT_ACCEPTED,
    getResponse: login_credentials,
  };
}

export function Forbidden() {
  return {
    type: types.USER_FORBIDDEN,
  };
}

export function ErrorSatus(Status) {
  return {
    type: types.USER_ERRORDETAILS,
    getResponse: Status,
  };
}

export function checkPasswordPolicy(new_password) {
  //check password policy
  return function (dispatch) {
    return APIutil.postData(url.password_policy, new_password)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function postEULA_Acceptance(Eula_details) {
  //POST EULA
  return function (dispatch) {
    return APIutil.postChangePassword(url.post_eula_acceptance, Eula_details)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function GetBacnetBuildingId(Id) {
  return function (dispatch) {
    return APIutil.getDataAPI(url.get_Bacnet_Building + "/" + Id)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function getUserDetailsAfterLogin() {
  return function (dispatch) {
    return APIutil.getDataAPI(url.user_details_after_login)
      .then((response) => {
        // return response;
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function GetTenantUserContext(username) {
  return function (dispatch) {
    return APIutil.getDataAPI(url.get_Tenant_Employees + "/" + username)
      .then((response) => {
        dispatch(
          actionToStoreSuccess(response, types.GET_EMPLOYEE_LIST_SUCCESSFULL)
        );
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function UpdateLogonTransaction(logondetails) {
  return function (dispatch) {
    return APIutil.postData(url.post_user_transaction, logondetails)
      .then((response) => {
        if (logondetails.LogOnTransaction == true)
          dispatch(
            actionToStoreSuccess(
              response.data,
              types.POST_USER_LOG_TRANSACTION_SUCCESSFULL
            )
          );
        else
          dispatch(
            actionToStoreSuccess(0, types.POST_USER_LOG_TRANSACTION_SUCCESSFULL)
          );
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function AppRolePermission(actionId, applicationId) {
  return function (dispatch) {
    return APIutil.getDataAPI(
      url.get_user_role_permission +
        "?actionId=" +
        actionId +
        "&applicationId=" +
        applicationId
    )
      .then((response) => {
        dispatch(actionToStoreSuccess(response, types.GET_USERROLE_PERMISSION));
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function WorkOrderRolePermission(applicationId) {
  return function (dispatch) {
    return APIutil.getDataAPI(
      url.get_user_role_permission_workorder +
        "?actionId=0&applicationId=" +
        applicationId
    )
      .then((response) => {
        dispatch(
          actionToStoreSuccess(response, types.GET_WORKORDERROLE_PERMISSION)
        );
      })
      .catch((error) => {
        throw error;
      });
  };
}

export function UpdateOnPremiseState(OnPremiseState) {
  return {
    type: types.SET_ONPREMISE_DETAIL,
    getResponse: OnPremiseState,
  };
}

export function UpdateEquipmentSummaryState(EquipmentSummaryState) {
  return {
    type: types.SET_EQUIPMENT_SUMMARY_DETAIL,
    getResponse: EquipmentSummaryState,
  };
}

export function ResetOnPrimiseError() {
  return function (dispatch) {
    dispatch(actionToStoreSuccess("", types.ONPRIMISE_ERRORRESET));
  };
}

export function actionToStoreSuccess(response, actionType) {
  return {
    type: actionType,
    getResponse: response,
  };
}
